import React, { createContext, useState, useContext } from 'react'
import { NotificationBarComponent } from '../components/notificationBarComponent'

interface NotificationBarContextInterface {
    push: (config: NotificationBarConfig) => NotificationBarConfig | void
    hide: (config: NotificationBarConfig) => void

}
const NotificationBarContext = createContext<NotificationBarContextInterface>({
    push: () => {},
    hide: () => { }
})

export interface NotificationBarConfig {
    title?: any
    message?: any
    type?: 'info' | 'error' | 'success' | 'progress'
    positionClass?: string
    _isHidden?: boolean
    _id?: number
    timeout?: number | 'infinite'
}

interface ComponentProps {
    children: any
}
export const NotificationBarProvider: React.FC<ComponentProps> = ({ children }) => {
    const [notifications, setNotifications] = useState<NotificationBarConfig[]>([])
    const push = (config: NotificationBarConfig) => {
        let existing = [...notifications]
        config._id = Math.round(Math.random() * Date.now())
        existing.unshift(config)
        setNotifications(existing)
        return config
    }    
    const hide = (config: NotificationBarConfig) => {
        let existing = [...notifications]
        let index = existing.findIndex(e=>e._id === config._id)
        if(index >= 0) {
            existing.splice(index, 1)
            // existing[index]._isHidden = true
        }
        setNotifications(existing)
    }

    const onCloseNotification = (config: NotificationBarConfig) => {
        hide(config);
    }
    return (
        <NotificationBarContext.Provider value={{ push, hide }}>
            <div className='fixed top-2 right-2 w-max z-50 gap-3 flex flex-col'>
                {
                    notifications.map((notification, index) => (
                        <NotificationBarComponent key={index} onClose={onCloseNotification} config={notification} />
                    ))
                }
            </div>
            {children}
        </NotificationBarContext.Provider>
    )
}

export const useNotificationBar = () => useContext(NotificationBarContext)